/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {finishPinwheelLink} from '../api'

export const useMutationFinishPinwheelLink = createReactQueryMutationHook('finishPinwheelLink', finishPinwheelLink)
